import { useContext } from "react";
import { CommonContext } from "../context/CommonContext";

export const useData = () => useContext(CommonContext);